import React, { useEffect, useRef } from "react";
import classes from "./FifthBlock.module.css";
import cn from "clsx";
import Typography from "src/components/ui-kit/Typography";
import Container from "src/components/ui-kit/Container";
import { useStaticQuery, graphql } from "gatsby";
import Img, { FluidObject } from "gatsby-image";
import { FifthBlockSlideshowQuery } from "types/graphql-types";
import Glider from "glider-js";
import "glider-js/glider.min.css";

interface FifthBlockProps {}

const FifthBlock: React.FC<FifthBlockProps> = () => {
  const slideshowItems: FifthBlockSlideshowQuery = useStaticQuery(graphql`
    query FifthBlockSlideshow {
      first: allFile(
        sort: { order: ASC, fields: relativePath }
        filter: { relativePath: { glob: "FifthBlock/1/*.jpg" } }
      ) {
        edges {
          node {
            base
            childImageSharp {
              fluid(maxWidth: 560) {
                ...GatsbyImageSharpFluid_noBase64
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
      second: allFile(
        sort: { order: ASC, fields: relativePath }
        filter: { relativePath: { glob: "FifthBlock/2/*.jpg" } }
      ) {
        edges {
          node {
            base
            childImageSharp {
              fluid(maxWidth: 560) {
                ...GatsbyImageSharpFluid_noBase64
                ...GatsbyImageSharpFluidLimitPresentationSize
              }
            }
          }
        }
      }
    }
  `);

  const gliderOneContainer = useRef<HTMLDivElement>(null);
  const gliderTwoContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!gliderOneContainer.current) {
      throw new Error("Glider container does not exists");
    }
    new Glider(gliderOneContainer.current, {
      slidesToShow: 1,
      dots: "#dots-one",
      draggable: true,
      arrows: {
        prev: "#glider-one-prev",
        next: "#glider-one-next",
      },
      itemWidth: 560,
    });
    if (!gliderTwoContainer.current) {
      throw new Error("Glider container does not exists");
    }
    new Glider(gliderTwoContainer.current, {
      slidesToShow: 1,
      dots: "#dots-two",
      draggable: true,
      arrows: {
        prev: "#glider-two-prev",
        next: "#glider-two-next",
      },
      itemWidth: 560,
    });
  });

  return (
    <div className={cn(classes.container)}>
      <Container>
        <Typography color="primary" variant="h2" component="h3">
          <b>Познакомиться и забрать домой</b>
        </Typography>
        <div className={cn(classes.twoColumns)}>
          <div>
            <Typography gutterBottom color="primary" isSemiTransperent>
              <b>
                Решили завести домашнего любимца? Поздравляем, это отличное
                решение! Домашнее животное — это счастье и много-много радости,
                но и большая ответственность. Вы будете заботиться в вашем
                питомце много лет, кормить, лечить, гулять. Ваша жизнь немного
                изменится, ведь теперь вы отвечаете еще за одну жизнь...
                Пожалуйста, подумайте и взвесьте свои возможности. Готовы?
              </b>
            </Typography>
            <Typography gutterBottom color="primary" isSemiTransperent>
              <b>
                На этом сайте вы можете познакомиться с животными приюта
                Petsvillage и подопечными социального сервиса Adoption-центр.
                Вас ждут животные, с которыми занимаются кураторы, волонтеры и
                просто неравнодушные люди, которые не прошли мимо и решили
                помочь.
              </b>
            </Typography>
            <Typography gutterBottom color="primary" isSemiTransperent>
              <b>
                Предлагаем начать знакомство с анкет животных. Если вам кто-то
                приглянулся — заполняйте анкету. Пожалуйста, не пропускайте
                поля, это поможет как вам (определиться, готовы ли вы), так и
                нам — быть уверенными в серьезности ваших намерений. Если вы не
                выбрали конкретного питомца в интернете, не беда! Заполняйте
                анкету и приходите знакомиться лично.
              </b>
            </Typography>
          </div>
          <div>
            <div className={cn("glider-contain", classes.slideshow)}>
              <div className="glider" ref={gliderOneContainer}>
                {slideshowItems.first.edges.map((n) => (
                  <Img
                    loading="eager"
                    key={n.node.base}
                    fluid={n.node.childImageSharp?.fluid as FluidObject}
                    className={cn(classes.slideshowImg)}
                  />
                ))}
              </div>

              <button
                aria-label="Предыдущее фото"
                id="glider-one-prev"
                className={cn("glider-prev", classes.slideshowPrev)}
              >
                <img
                  src={require("./assets/left.svg")}
                  alt="Стрелочка налево"
                />
              </button>
              <button
                aria-label="Следующее фото"
                id="glider-one-next"
                className={cn("glider-next", classes.slideshowNext)}
              >
                <img
                  src={require("./assets/right.svg")}
                  alt="Стрелочка направо"
                />
              </button>
              <div role="tablist" className="dots" id="dots-one"></div>
            </div>
          </div>
        </div>
        <div className={cn(classes.twoColumns)}>
          <div className={cn(classes.mobileOrderOne)}>
            <div className={cn("glider-contain", classes.slideshow)}>
              <div className="glider" ref={gliderTwoContainer}>
                {slideshowItems.second.edges.map((n) => (
                  <Img
                    loading="eager"
                    key={n.node.base}
                    fluid={n.node.childImageSharp?.fluid as FluidObject}
                    className={cn(classes.slideshowImg)}
                  />
                ))}
              </div>

              <button
                aria-label="Предыдущее фото"
                id="glider-two-prev"
                className={cn("glider-prev", classes.slideshowPrev)}
              >
                <img
                  src={require("./assets/left.svg")}
                  alt="Стрелочка налево"
                />
              </button>
              <button
                aria-label="Следующее фото"
                id="glider-two-next"
                className={cn("glider-next", classes.slideshowNext)}
              >
                <img
                  src={require("./assets/right.svg")}
                  alt="Стрелочка направо"
                />
              </button>
              <div role="tablist" className="dots" id="dots-two"></div>
            </div>
          </div>
          <div>
            <Typography gutterBottom color="primary" isSemiTransperent>
              <b>
                Мы свяжемся с вами в течение трех дней. Пригласим познакомиться
                с будущим любимцем или выбрать его среди подопечных
                Adoption-центра. Вас ждет два собеседования: до знакомства и
                после того, как вы выберете нового друга. Немного времени
                подумать — и можно ехать домой!
              </b>
            </Typography>
            <Typography gutterBottom color="primary" isSemiTransperent>
              <b>
                Сотрудники центра расскажут вам о характере и особенностях
                понравившегося кота или пса. Мы хорошо знаем наших подопечных, и
                подскажем, кого стоит взять в большую семью, кто любит долгие
                прогулки, кто тихоня и домосед. Также мы передадим вам полную
                медицинскую историю животного.
              </b>
            </Typography>
            <Typography gutterBottom color="primary" isSemiTransperent>
              <b>
                Все наши питомцы стерилизованы, привиты и чипированы. Все прошли
                карантин, необходимую социализацию и готовы ехать в новый дом.
                Наши кошки приучены к лотку, а собаки — к прогулкам два раза в
                день.
              </b>
            </Typography>
            <Typography gutterBottom color="primary" isSemiTransperent>
              <b>
                Мы поможем вам в выборе нового друга и будем ненавязчиво следить
                за судьбой наших подопечных. Будем рядом на первых шагах, ведь
                вас ждет период адаптации (он может занять от нескольких дней до
                пары недель), а также готовы помогать и дальше. Забирая у нас
                животное, вы заключаете договор ответственного владельца,
                получаете паспорт питомца, номер чипа, медицинскую карту и,
                самое главное, нового замечательного друга.
              </b>
            </Typography>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FifthBlock;
